<template>
  <!-- 对话框 -->
  <transition name="hehe1">
    <div v-show="add_order_show" class="tip-box">
      <i class="el-icon-warning" v-if="type_msg == 'error'" style="color: rgb(236, 59, 28);"></i>
      <i class="el-icon-success" v-else style="color: rgb(0, 128, 6);"></i>

      <!--   显示文字   -->
      {{ text_data.msg }}

      <p style="height: 60px;line-height: 60px;border-bottom: 5px solid rgb(117, 117, 117); color: red;" v-if="text_data.assign_mode_name == '强制指派'">
        {{ text_data.assign_mode_name }}
      </p>

      <p style="height: 60px;line-height: 60px;border-bottom: 5px solid rgb(117, 117, 117);" v-else>
        {{ text_data.assign_mode_name }}
      </p>



      <div style="height: 120px; overflow-y: auto; margin: 20px 0;">

        <div v-for="(item, index) in text_data.driver_lists" style="margin: 20px 0; display: flex;" class="driver-box">
          <p>{{index+1}}.司机姓名：{{ item.real_name }}</p>
          <p style="margin: 0 10px;">距离：{{ Math.floor(item.distance) }}米</p>
          <p>综合分数：{{ item.exponent_points }}</p>
        </div>


      </div>
      <div style="text-align: center; margin-bottom: 10px;">
        <el-button @click="closeDialog" type="danger">关闭{{time}}s</el-button>
      </div>

    </div>
  </transition>

</template>

<script>
  var _this;

  export default {

    props: {
      'isShow': Boolean,
      'data': '',
      'type_data': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.add_order_show = true;

        _this.text_data = _this.data;

        _this.type_msg = _this.type_data;

        // setTimeout(() => {
        //   _this.add_order_show = false;
        // }, 4000);

        var t = setInterval(() => {
          if (_this.time == 0) {

            clearInterval(t);

            _this.closeDialog();

          } else {

            _this.time -= 1;

          }


        }, 1000);

      },
    },
    data() {
      return {
        time: 4,

        add_order_show: false,

        text_data: '',

        type_msg: ''

      };
    },
    created() {

      _this = this;

    },
    methods: {




      closeDialog() {


        _this.add_order_show = false;

        _this.text_data = '';

        _this.time = 4;

        _this.type_msg = '';

      },



    }
  };
</script>

<style scoped>
  #container_add {
    height: 90%;
    width: 65%;
    float: left;
  }

  .order-model {
    margin: 20px 0;
  }


  .mode-data {

    margin: 20px 0;
  }

  .hehe1-enter,
  .hehe1-leave-to {
    opacity: 0;
  }

  .hehe1-enter-to,
  .hehe1-leave {
    opacity: 1;
  }

  .hehe1-enter-active,
  .hehe1-leave-active {
    transition: all .5s;
  }

  .tip-box {
    max-width: 90%;
    /* padding: 40px; */
    padding: 10px 50px;
    box-sizing: border-box;
    font-size: 30px;
    border-radius: 20px;
    background-color: rgba(255, 255, 255, .8);
    box-shadow: 5px 5px 10px rgb(168, 168, 168);
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 999999;
    transform: translate(-50%, -50%);
    text-align: center;
  }
  .driver-box{
    font-size: 14px;
    font-weight: 500;
    color: 000;
  }

</style>
